var React = require('react');

function Expand (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M10.112 12.429a.461.461 0 0 1-.134.308L5.53 17.183l1.929 1.929c.16.16.254.375.254.602a.863.863 0 0 1-.857.857h-6A.863.863 0 0 1 0 19.714v-6c0-.468.388-.857.857-.857.228 0 .442.094.603.255l1.928 1.928 4.447-4.446a.46.46 0 0 1 .308-.134c.107 0 .228.053.308.134l1.527 1.527c.08.08.134.2.134.308zM20.572.857v6a.863.863 0 0 1-.858.857.852.852 0 0 1-.602-.254l-1.929-1.93-4.446 4.447a.463.463 0 0 1-.308.134.461.461 0 0 1-.308-.134L10.594 8.45a.461.461 0 0 1-.134-.308c0-.107.053-.228.134-.308l4.446-4.447-1.928-1.928a.852.852 0 0 1-.255-.603c0-.469.389-.857.857-.857h6c.47 0 .857.388.857.857z"}));
}

Expand.defaultProps = {"viewBox":"0 0 29 29"};

module.exports = Expand;

Expand.default = Expand;
